class SubscriptionSuccessCtrl {
  close() {
    this.closeModal();
  }
}

export default SubscriptionSuccessCtrl;
